module.exports = __webpack_public_path__ + "img/light-switch-on.d92f343d.svg";